module.exports = __webpack_public_path__ + "static/media/manager-b-2.5f079b46.png";